import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Divider, 
  Button, 
  Link as MuiLink,
  Stack,
  IconButton
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  Email as EmailIcon,
  LinkedIn as LinkedInIcon,
  GitHub as GitHubIcon,
  Twitter as TwitterIcon
} from '@mui/icons-material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: '#0f172a', // Modern dark slate
        color: '#94a3b8',
        pt: 8,
        pb: 4,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'rgba(255,255,255,0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          <Grid {...{ item: true, xs: 12, md: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 3 }}>
              <Box 
                component="img" 
                src="/zandrigo_futuristic_optimized_dark_bg.svg?v=11" 
                alt="Zandrigo Logo" 
                sx={{ height: 60 }} 
              />
            </Box>
            <Typography variant="overline" sx={{ color: 'primary.light', fontWeight: 700, letterSpacing: '0.1em' }}>
              Venture Architect
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3, mt: 1, lineHeight: 1.7 }}>
              Digital Transformation | Automation | High Performing Tech Teams
            </Typography>
            <Stack direction="row" spacing={1}>
              {[<LinkedInIcon key="li" />, <GitHubIcon key="gh" />, <TwitterIcon key="tw" />].map((icon, i) => (
                <IconButton key={i} size="small" sx={{ color: '#94a3b8', '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}>
                  {icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
          
          <Grid {...{ item: true, xs: 12, sm: 6, md: 2 }}>
            <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 700, mb: 3, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
              Product
            </Typography>
            <Stack spacing={2}>
              {['Projects', 'Visualizer', 'Risks', 'Reports'].map((text) => (
                <MuiLink key={text} component={RouterLink} to={`/${text.toLowerCase()}`} sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>
                  {text}
                </MuiLink>
              ))}
            </Stack>
          </Grid>
          
          <Grid {...{ item: true, xs: 12, sm: 6, md: 2 }}>
            <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 700, mb: 3, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
              Expertise
            </Typography>
            <Stack spacing={2}>
              <MuiLink href="https://viana.one" target="_blank" rel="noopener" sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>
                Tech Consulting
              </MuiLink>
              <MuiLink href="#" sx={{ color: 'white', fontWeight: 600, textDecoration: 'none', fontSize: '0.875rem', mt: 1 }}>
                Zandrigo.ai
              </MuiLink>
              {['Data Analysis', 'Computer Vision', 'Organizational Consultancy', 'Software Engineering'].map((text) => (
                <Typography key={text} variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem', pl: 1 }}>
                  • {text}
                </Typography>
              ))}
              <MuiLink component={RouterLink} to="/contact" sx={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>
                Legal AI Systems
              </MuiLink>
            </Stack>
          </Grid>
          
          <Grid {...{ item: true, xs: 12, md: 4 }}>
            <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 700, mb: 3, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
              Contact
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3 }}>
              Looking for expert consulting or a custom solution? Reach out to Ilisio Viana.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<EmailIcon />}
              component={RouterLink}
              to="/contact"
              fullWidth
              sx={{ py: 1.5, fontWeight: 700, borderRadius: 2 }}
            >
              Get in Touch
            </Button>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.1)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            © {currentYear} Zandrigo by Ilisio Viana.
          </Typography>
          <Stack direction="row" spacing={3}>
            <MuiLink href="#" sx={{ color: '#64748b', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>Privacy Policy</MuiLink>
            <MuiLink href="#" sx={{ color: '#64748b', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>Terms of Service</MuiLink>
            <MuiLink href="#" sx={{ color: '#64748b', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}>Cookies</MuiLink>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;